import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { IAppState, QAProps } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { LOC_KEY_MENU_PANEL_HOME } from "../../locKeys";
import { isFocused, LOGO_FOCUSABLE_ID, MenuNavigationSectionType } from "../../navigation";
import { MenuPanelItemId } from "../../panelItems";
import { MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createMenuItemMouseActivationHandler } from "../../utils";
import { LogoComponent, LogoComponentProps } from "../LogoComponent";

export type LogoProps = QAProps;

type StateProps = Pick<LogoComponentProps, "ariaLabel" | "title" | "isFocused">;

const mapStateToProps: MapStateToProps<StateProps, LogoProps, IAppState> = (state) => ({
    ariaLabel: getPrimaryText(state, LOC_KEY_MENU_PANEL_HOME),
    title: getSecondaryText(state, LOC_KEY_MENU_PANEL_HOME),
    isFocused: isFocused(state, LOGO_FOCUSABLE_ID),
});

type DispatchProps = {
    logoActivated: typeof createMenuItemActivatedAction;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, LogoProps> = {
    logoActivated: createMenuItemActivatedAction,
};

const mergeProps: MergeProps<StateProps, DispatchProps, LogoProps, LogoComponentProps> = ({ ariaLabel, title, isFocused }, { logoActivated }, { qa }) => ({
    ariaLabel,
    title,
    isFocused,
    onClick: createMenuItemMouseActivationHandler(MenuPanelItemId.logo, MenuItemActivatedType.logoButton, MenuNavigationSectionType.static, logoActivated),
    onKeyUp: createMenuItemKeyActivationHandler(MenuPanelItemId.logo, MenuItemActivatedType.logoButton, MenuNavigationSectionType.static, logoActivated),
    qa,
});

/** Definuje onClick pro komponentu loga. */
export const Logo = connect(mapStateToProps, mapDispatchToProps, mergeProps)(LogoComponent);
